/* Positioning and layout of the fixed chrome. Looks come from ui.module.css + tokens. */

.toolbar {
  position: absolute;
  top: var(--chrome-inset);
  left: var(--chrome-inset);
  z-index: var(--z-chrome);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px;
  max-width: calc(100vw - var(--chrome-inset) * 2 - 300px);
  padding: var(--space-1);
}

/* Native selects share the toolbar's control height. */
.select {
  font-size: var(--text-md);
}

.select select {
  padding: 4px 24px 4px 8px;
  border-radius: var(--radius);
}

.statusbar {
  position: absolute;
  bottom: var(--chrome-inset);
  left: var(--chrome-inset);
  z-index: var(--z-chrome);
  display: flex;
  gap: 18px;
  padding: 6px var(--space-3);
  font-family: var(--font-mono);
  font-size: var(--text-sm);
  color: var(--ink-soft);
}

.statusbar b {
  font-weight: 500;
  color: var(--ink);
}

/* ---- Viewport controls (bottom-right, on-canvas) ---- */
.viewportControls {
  position: absolute;
  right: var(--chrome-inset);
  bottom: calc(var(--chrome-inset) + var(--safe-bottom));
  display: flex;
  align-items: center;
  gap: 2px;
  padding: var(--space-1);
  pointer-events: auto;
}

.zoomReadout {
  min-width: 52px;
  font-family: var(--font-mono);
  font-size: var(--text-sm);
  color: var(--ink-soft);
}

/* ---- Compact (phone) layout ---- */
.toolbarCompact {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: calc(10px + var(--safe-bottom));
  z-index: var(--z-chrome);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2px;
  padding: 6px;
  border-radius: var(--radius-lg);
}

.toolbarCompact select {
  flex: 1;
  min-width: 0;
  height: 40px;
}

@media (max-width: 639px) {
  .statusbar {
    display: none;
  }

  .viewportControls {
    right: 10px;
    bottom: calc(66px + var(--safe-bottom));
  }
}

@media (max-width: 1023px) {
  .toolbar {
    max-width: calc(100vw - var(--chrome-inset) * 2 - 250px);
  }
}

/* ---- Developer panel (top-right, below the inspector's slot when both are open) ---- */
.developer {
  position: absolute;
  top: 70px;
  left: var(--chrome-inset);
  z-index: var(--z-chrome);
  width: 300px;
  padding: var(--space-2) var(--space-3) var(--space-3);
  font-family: var(--font-mono);
  font-size: var(--text-sm);
}

.developerHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.developerList {
  margin: 0;
  display: grid;
  gap: 3px;
}

.developerList > div {
  display: grid;
  grid-template-columns: 82px 1fr;
  gap: var(--space-2);
}

.developerList dt {
  color: var(--ink-faint);
}

.developerList dd {
  margin: 0;
  overflow-wrap: anywhere;
}

@media (max-width: 639px) {
  .developer {
    display: none;
  }
}
